<template>
  <div class="img-link-fixed" v-show="show">
    <img-v3 :src="formItem.img_url" />
    <div v-if="formItem.title" class="img-title">
      <img-v3 v-if="formItem.title_icon" :src="formItem.title_icon" /><!--
        --><span>{{ formItem.title }}</span>
    </div>
    <div v-if="formItem.download" class="img-download" @click="goLink">
      <img-v3 v-if="formItem.download.icon" :src="formItem.download.icon" /><!--
        --><span>{{ formItem.download.title }}</span>
    </div>
    <p v-if="formItem.desc" class="img-desc">{{ formItem.desc }}</p>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { ends } from "../../tools/constant";
import { getEnd } from "../../tools/utils";

export default {
  props: ["formItem", "idx"],
  methods: {
    reset() {
      Fusion.resetBack &&
        Fusion.resetBack({
          reset: 2,
        });
      //20200228 vamos设置返回拦截
      Fusion.interceptGoback &&
        Fusion.interceptGoback({ needs_intercept: false }, () => {});
    },
    goLink() {
      if (this.formItem.link) {
        if (ends.isIOS) {
          location.href = this.linkGenerator(this.formItem.link.ios);
        } else {
          location.href = this.linkGenerator(this.formItem.link.android);
        }
      }
    },
    linkGenerator(url) {
      const onelinkGenerator = new window.AF.OneLinkUrlGenerator({
        oneLinkURL: url,
        pidKeysList: ["source"],
        // pidOverrideList: {
        //   'joveo': 'joveo_int',
        //   'jampp': 'jampp_int',
        //   'google': 'googleadwords_int',
        //   'facebook':'Facebook Ads'
        // },
        campaignKeysList: ["utm_campaign"],
      });
      onelinkGenerator.setChannel("utm_source"); // Input value
      onelinkGenerator.setCustomParameter("campaign_id", "af_c_id"); // Input Output value
      onelinkGenerator.setAdset("ad_group_id");
      onelinkGenerator.setAd("creative_id");
      onelinkGenerator.setCustomParameter("keyword", "af_keywords");
      onelinkGenerator.setCustomParameter("adposition", "af_siteid");
      onelinkGenerator.setAfSub1("gclid");
      onelinkGenerator.setAfSub2("fbclid");
      return onelinkGenerator.generateUrl();
    },
  },
  computed: {
    ...mapState(["_ticket", "_product"]),
    show() {
      let end = getEnd();
      let d = this.formItem.display;
      if (!d) {
        return true;
      }
      return d.indexOf(end) > -1;
    },
  },
};
</script>
<style lang="scss" scoped>
.img-link-fixed {
  position: absolute;
  bottom: 0;
  left: 0;
  .img-title {
    position: absolute;
    width: 45%;
    top: 0.3rem;
    right: 0.32rem;
    text-align: right;
    font-size: 0.32rem;
    > img {
      height: 0.32rem;
      margin-right: 0.16rem;
      vertical-align: top;
    }
    > span {
      font-weight: 700;
      color: #333333;
    }
  }
  .img-download {
    position: absolute;
    min-width: 2.46rem;
    top: 0.8rem;
    right: 0.32rem;
    box-sizing: border-box;
    padding: 0.16rem 0.32rem;
    background: #ff7226;
    border-radius: 32px;
    font-size: 0.28rem;
    text-align: center;
    > img {
      width: 0.28rem;
      margin-right: 0.12rem;
    }
    > span {
      font-weight: 700;
      color: #ffffff;
      // vertical-align: top;
      position: relative;
      top: -2px;
    }
  }
  .img-desc {
    position: absolute;
    bottom: 0;
    right: 0;
    margin: 0.32rem;
    font-size: 0.24rem;
    color: #333333;
    text-align: right;
    font-weight: 500;
  }
  > img {
    display: block; //解决下边距3px空白
    width: 100%;
  }
}
</style>

